import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from 'react-redux'

import Dashboard from '../../../pages/dashboard/Dashboard'
import DashboardHM from '../../../pages/dashboard/DashboardHM'
import ManageVehicles from '../../smart/menuComponentsContainer/ManageVehicles'
import Events from '../../dump/menuComponents/Events'
import ManageDriversPage from '../../../pages/drivers/ManageDriversPage'
import Reports from '../../dump/menuComponents/Reports'
import ManageAssetsGroups from '../../dump/menuComponents/ManageAssetsGroups'

import { apiCall } from '../../../action/RouterActions'

const HomeAccess = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = props;
    const userRole = user.roles[0];

    if (!user) {
        return (<div />)
    }
    if (['fleet_maintainer', 'installer'].indexOf(userRole) > -1) {
        return <ManageVehicles />
    }
    if (['storage_manager', 'storage_user'].indexOf(userRole) > -1) {
        return <Events />
    }
    if (['custom_user', 'custom_partner'].includes(userRole)) {
        const userPermissions = user.permissions
        const permissions = userPermissions
            .filter(e => e.perm_category_name !== 'Other' && e.a_view === true)
            .map(({ perm_category_id }) => perm_category_id)

        if (permissions.length && !permissions.includes(1)) {
            if (permissions.includes(2)) {
                return <Events />
            }
            if (permissions.includes(3)) {
                return <Reports />
            }
            if (permissions.includes(4)) {
                return <ManageVehicles location={{ state: { tabKey: 1 } }} />
            }
            if (permissions.includes(5)) {
                return <ManageVehicles />
            }
            if (permissions.includes(6)) {
                return <ManageAssetsGroups />
            }
            if (permissions.includes(11)) {
                return <ManageDriversPage />
            }
            if (permissions.includes(15)) {
                return <ManageVehicles location={{ state: { tabKey: 2 } }} />
            }
            if (permissions.includes(16)) {
                return <ManageUsers />
            }
            if (permissions.includes(17)) {
                return <Firmware />
            }
            navigate('/not-found');
        }
        else if (!permissions.length) {
            navigate('/not-found');
            return;
        }
    }

    const storedMap = JSON.parse(localStorage.getItem("storedMap"));
    if (!storedMap) {
        localStorage.setItem("storedMap", JSON.stringify({ start: Date.now(), feedback: false, type: "here" }));
    }
    const isNewMap = !storedMap || storedMap?.type === "here";
    const mapType = user.map_type_using[user.map_type_using.length - 1]?.type;

    if ((mapType === "google" && isNewMap) || (mapType === "here" && !isNewMap) || !user.map_type_using.length) {
        apiCall('POST', '/users/map-type-using', { map_type: isNewMap ? "here" : "google" });
    }

    if (location && location.state) {
        return (isNewMap ? <DashboardHM location={location} /> : <Dashboard location={location} />)
    }

    return (isNewMap ? <DashboardHM /> : <Dashboard />);
}

export default connect(
    state => ({
        user: state.user.user,
        renderHomepage: state.dashboardData.renderHomepage, // FWSD-7380, changing of this global state rerenders the Homepage and Map there
    }),
)(HomeAccess);
